// extracted by mini-css-extract-plugin
module.exports = {"try":"TryButtonBaga-try-1d13","combo":"TryButtonBaga-combo-1d13","both":"TryButtonBaga-both-1d13","load":"TryButtonBaga-load-1d13","hide":"TryButtonBaga-hide-1d13"};